import { useId } from 'react';

/**
 * TO or CC, the same way everywhere she looks (SPEC-christa-contacts-identity R1 AC16).
 *
 * The Bill To recipients list, the Create Invoice preview and the client's default contacts list all use this,
 * so a person can never be "TO" on one panel and unlabelled on the next. TO is the person the invoice goes to
 * ("Main recipient"); CC gets a copy ("Gets a copy"). The text is in the title (tooltip) and in an accessible
 * description, not only in a colour.
 */
export type RecipientRole = 'to' | 'cc';

const COPY: Record<RecipientRole, { label: string; hint: string }> = {
  to: { label: 'TO', hint: 'Main recipient' },
  cc: { label: 'CC', hint: 'Gets a copy' },
};

export function roleHint(role: RecipientRole): string {
  return COPY[role].hint;
}

export function RoleBadge({ role, className = '' }: { role: string | null | undefined; className?: string }) {
  const hintId = useId();
  if (role !== 'to' && role !== 'cc') return null;
  const { label, hint } = COPY[role];
  return (
    <>
      <span
        className={`inline-block rounded border border-slate-300 px-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-600 ${className}`}
        title={hint}
        aria-describedby={hintId}
        data-testid={`role-label-${role}`}
      >
        {label}
      </span>
      <span id={hintId} className="sr-only">{hint}</span>
    </>
  );
}
